<template>
  <div class="row">
    <div class="col-12">
      <div class="row mt-3">
        <div class="col">
          <button @click="toggleObjectivesContentView('detail')" type="button" class="btn btn-sm btn-outline-dark">&lt; {{ $t("general.back") }}</button>
        </div>
      </div>
      <div class="row mt-3">
        <div class="col-12">
          <div class="h3">
            {{ $t("views.objective.edit.heading") }}
            <DocsInfoLink color="dark" target="createObjective"></DocsInfoLink>
          </div>
        </div>
      </div>
      <div class="row my-3">
        <div class="col-12">
          <span v-for="(value, key) in smart" :key="'smart-' + key" :class="value ? 'text-bg-success' : 'text-bg-danger'" class="badge fs-5 fw-normal px-2 py-1 me-2">{{ key }}</span>
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <div class="progress">
            <div class="progress-bar" role="progressbar" :style="progress.width" aria-valuemin="0" aria-valuemax="100"></div>
          </div>
        </div>
      </div>
      <div class="row mt-3">
        <div class="col-12">
          <div class="card w-100">
            <div class="card-body">
              <div class="row mb-5">
                <div class="col-4">
                  <label for="orgUnit" class="form-label">
                    {{ $t("views.objective.edit.orgUnit") }}<span class="text-danger">*</span>
                  </label>
                  <select v-model="newObjective.orgUnit" id="orgUnit" class="form-select">
                    <option v-for="orgUnit in orgUnitsList" :key="orgUnit.id" :value="orgUnit.id">{{ orgUnit.name }}</option>
                  </select>
                </div>
                <div class="col-5 offset-2">
                  <label for="parentId" class="form-label">
                    {{ $t("views.objective.edit.parentObjective") }}<span class="text-danger">*</span>
                  </label>
                  <select v-model="newObjective.parentId" id="parentId" class="form-select">
                    <option value="0">{{ $t("views.objective.edit.noParentObjective") }}</option>
                    <option v-for="objective in objectivesList" :key="objective.id" :value="objective.id" :disabled="objective.org ? true : false">
                      {{ objective.name }}
                    </option>
                  </select>
                </div>
              </div>
              <div class="row mb-5">
                <div class="col-5">
                  <div class="row">
                    <div class="col-12">
                      <label for="name" class="form-label w-100">
                        <div class="row">
                          <div class="col-6">
                            {{ $t("views.objective.edit.name") }}<span class="text-danger">*</span>
                          </div>
                          <div class="col-6 text-end">
                            <div>
                              <input v-model="newObjective.category" id="checkCategory" class="form-check-input" type="checkbox">
                              <label class="form-check-label ms-1" for="checkCategory">
                                {{ $t("views.objective.edit.breakthrough") }}
                              </label>
                            </div>
                          </div>
                        </div>
                      </label>
                      <input v-model="newObjective.name" id="name" :class="form.name.error === '' ? 'form-control' : 'form-control is-invalid'">
                      <div class="invalid-feedback">{{ form.name.error }}</div>
                    </div>
                  </div>
                </div>
                <div class="col-4 offset-1">
                  <label for="responsible" class="form-label">
                    {{ $t("views.objective.edit.responsible") }}
                  </label>
                  <select v-model="newObjective.responsible" id="responsible" class="form-select">
                    <option v-for="person in employees" :key="person.id" :value="person.id">
                      {{ person.lastName }}, {{ person.firstName }}
                    </option>
                  </select>
                </div>
              </div>
              <div class="row mb-5">
                <div class="col-5">
                  <label for="description" class="form-label">
                    {{ $t("views.objective.edit.description") }}
                  </label>
                  <RTEditor ref="rtEditor-description" v-model="newObjective.description" contentType="html" id="description"></RTEditor>
                </div>

                <div class="col-6 offset-1">

                  <!-- Radio Buttons Time Intervall / Objective type-->
                  <div class="row">
                    <label class="form-label">{{ $t("views.objective.edit.timeInterval") }}<span class="text-danger">*</span></label>
                  </div>

                  <div class="mb-3">
                    <!-- multi-year breakthrough -->
                    <div class="form-check form-check-inline">
                      <input  class="form-check-input" type="radio" name="objectiveCategory" id="objectiveCategoryBreakthrough"  :value="1" v-model.number="newObjective.category" :disabled="!categoryEnabled[1]" >
                      <label class="form-check-label ms-1" for="objectiveCategoryBreakthrough"> {{ $t("views.objective.edit.breakthrough") }} </label>
                    </div>

                    <!-- yearly objective -->
                    <div class="form-check form-check-inline">
                      <input class="form-check-input" type="radio" name="objectiveCategory" id="objectiveCategoryYear" :value="0" v-model.number="newObjective.category" :disabled="!categoryEnabled[0]">
                      <label class="form-check-label ms-1" for="objectiveCategoryYear"> {{ $t("views.objective.edit.yearly") }} </label>
                    </div>

                    <!-- quarterly objective -->
                    <div class="form-check form-check-inline">
                      <input class="form-check-input" type="radio" name="objectiveCategory" id="objectiveCategoryQuarter" :value="2" v-model.number="newObjective.category" :disabled="!categoryEnabled[2]">
                      <label class="form-check-label ms-1" for="objectiveCategoryQuarter"> {{ $t("views.objective.edit.quarterly") }} </label>
                    </div>
                  </div>

                  <!-- Select Time Interval, validFrom, validTo -->
                  <div class="row mb-3">

                    <!-- Breakthrough: Startjahr -->
                    <div class="col-3" v-if="newObjective.category === 1">
                      <label class="form-label"> {{ $t("views.objective.edit.yearFrom") }} <span class="text-danger">*</span> </label>
                      <select class="form-select" v-model.number="breakthroughStartYear">
                        <option v-for="y in nextYears" :key="y" :value="y">{{ y }}</option>
                      </select>
                    </div>

                    <!-- Breakthrough: Endjahr -->
                    <div class="col-3" v-if="newObjective.category === 1">
                      <label class="form-label"> {{ $t("views.objective.edit.yearTo") }} <span class="text-danger">*</span> </label>
                      <select class="form-select" v-model.number="breakthroughEndYear">
                        <option v-for="y in nextYears" :key="y" :value="y">{{ y }}</option>
                      </select>
                    </div>

                    <!-- Jahresziel -->
                    <div class="col-3" v-if="newObjective.category === 0">
                      <label class="form-label"> {{ $t("views.objective.edit.year") }} <span class="text-danger">*</span> </label>
                      <select class="form-select" v-model.number="selectedYear">
                        <option v-for="y in nextYears" :key="y" :value="y">{{ y }}</option>
                      </select>
                    </div>

                    <!-- Quartalsziel -->
                    <div class="col-3" v-if="newObjective.category === 2">
                      <label class="form-label"> {{ $t("views.objective.edit.quarter") }} <span class="text-danger">*</span> </label>
                      <select class="form-select" v-model="selectedQuarter">
                        <option v-for="q in nextQuarters" :key="q.value" :value="q.value"> {{ q.label }} </option>
                      </select>
                    </div>

                    <!-- Startdatum -->
                    <div class="col-3">
                      <label for="validFrom" class="form-label"> {{ $t("views.objective.edit.validFrom") }} </label>
                      <input v-model="newObjective.validFrom" type="date" id="validFrom" class="form-control" :disabled="true" >
                    </div>

                    <!-- Enddatum -->
                    <div class="col-3">
                      <label for="validTo" class="form-label"> {{ $t("views.objective.edit.validTo") }} </label>
                      <input v-model="newObjective.validTo" type="date"  id="validTo" class="form-control" :disabled="true" >
                    </div>

                  </div>

                </div>
              </div>

              <div class="row">
                <div class="col-12">
                  <div class="mb-2">{{ $t("views.objective.edit.performanceBenchmarks") }}</div>
                  <div class="btn-group btn-group-objectives-view" role="group">
                    <button @click="toggleCriterion('KRT')" type="button" class="btn btn-sm btn-outline-primary" :class="criterion === 'KRT' ? 'active' : ''">{{ $t("views.objective.edit.btnKeyResults") }}</button>
                    <span class="mx-2 mt-1">- {{ $t("general.or") }} -</span>
                    <button @click="toggleCriterion('KPI')" type="button" class="btn btn-sm btn-outline-primary" :class="criterion === 'KPI' ? 'active' : ''">{{ $t("views.objective.edit.btnKPIs") }}</button>
                  </div>
                </div>
              </div>
              <div v-if="criterion === 'KRT'" class="mt-3 mb-2">
                <div>
                  <button @click="addKeyResult()" type="button" class="btn btn-sm btn-outline-primary mt-auto">+ {{ $t("views.objective.edit.btnAddKeyResult") }}</button>
                </div>
                <div v-for="keyresult, index in newObjective.keyresults" :key="'keyresult' + index" class="row mt-3">
                  <div class="col-3">
                    <label for="name" class="form-label">
                      {{ $t("views.objective.edit.keyResultName") }}<span class="text-danger">*</span>
                    </label>
                    <input v-model="keyresult.name" id="keyresultName" class="form-control">
                  </div>
                  <div class="col-3">
                    <label for="name" class="form-label">
                      {{ $t("views.objective.keyresult.unit") }}<span class="text-danger">*</span>
                    </label>
                    <input v-model="keyresult.unit" id="keyresultUnit" class="form-control">
                  </div>
                  <div class="col-2">
                    <label for="name" class="form-label">
                      {{ $t("views.objective.keyresult.jop") }}<span class="text-danger">*</span>
                    </label>
                    <input v-model="keyresult.jop" type="number" id="keyresultJOP" class="form-control">
                  </div>
                  <div class="col-2">
                    <label for="name" class="form-label">
                      {{ $t("views.objective.edit.keyResultObjective") }}<span class="text-danger">*</span>
                    </label>
                    <input v-model="keyresult.obj" type="number" id="keyresultObjective" class="form-control">
                  </div>
                  <div class="col-1 mt-auto">
                    <button @click="deleteKeyResult(index)" class="btn btn-outline-danger" type="button">
                      <svg class="bi" width="18" height="18" fill="currentColor">
                        <use xlink:href="@/assets/icons/icons.svg#trash-fill"/>
                      </svg>
                    </button>
                  </div>
                </div>
              </div>
              <div v-if="criterion === 'KPI'" class="mt-3 mb-2">
                <div class="row">
                  <div class="col-4">
                    <select @change="addKPI()" v-model="kpiSelected" id="kpis" class="form-select">
                      <option :value="{ id: 0, name: 'Auswählen...' }">{{ kpiSelected.name }}</option>
                      <option v-for="kpi in kpisList" :key="kpi.id" :value="kpi" :disabled="kpi.folder ? true : false">{{ kpi.name }}</option>
                    </select>
                  </div>
                </div>
                <div class="row selected-kpis">
                  <div class="col-12">
                    <div v-for="userSelectedKPI in newObjective.kpis" :key="'user-selected-kpi' + userSelectedKPI.id" class="input-group input-group-sm mt-3">
                      <span class="input-group-text">
                        {{ userSelectedKPI.name }}
                      </span>
                      <button @click="deleteKPI()" class="btn btn-sm btn-outline-danger" type="button">
                        <svg class="bi" width="18" height="18" fill="currentColor">
                          <use xlink:href="@/assets/icons/icons.svg#trash-fill"/>
                        </svg>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row my-3">
        <div class="col text-end">
          <input v-model="newObjective.ambitious" id="checkNameAmbitious" class="form-check-input" type="checkbox">
          <label class="form-check-label ms-1" for="checkNameAmbitious">
            {{ $t("views.objective.edit.ambitious") }}<span class="text-danger">*</span>
          </label>
          <input v-model="newObjective.realistic" id="checkNameRealistic" class="form-check-input ms-3" type="checkbox">
          <label class="form-check-label ms-1" for="checkNameRealistic">
            {{ $t("views.objective.edit.realistic") }}<span class="text-danger">*</span>
          </label>
          <button @click="save()" type="button" class="btn btn-sm btn-primary ms-3" :class="progress.value >= 100 ? '' : 'disabled'">{{ $t("views.objective.edit.btnSave") }}</button>
        </div>
      </div>
      <KPIPeriodsModal :kpi="selectedKPI"></KPIPeriodsModal>
      <KPIRecordEditModal :kpi="selectedKPI"></KPIRecordEditModal>
    </div>
  </div>
</template>

<script>
import * as validate from '../../composables/validation'
import DocsInfoLink from '../../components/DocsInfoLink.vue'
import RTEditor from '../RTEditor.vue'
import KPIPeriodsModal from '../monitoring/KPIPeriodsModal.vue'
import KPIRecordEditModal from '../../components/monitoring/KPIRecordEditModal.vue'

export default {
  name: 'ObjectivesManageObjectiveAdd',
  data () {
    return {
      checkNameAmbitious: false,
      checkNameRealistic: false,
      criterion: '',
      kpiSelected: { id: 0, name: 'Auswählen...' },
      form: {
        orgUnit: {
          error: '',
          validate: ['empty']
        },
        parentId: {
          error: '',
          validate: []
        },
        name: {
          error: '',
          maxLength: 255,
          validate: ['empty', 'length']
        },
        responsible: {
          error: '',
          validate: []
        },
        category: {
          error: '',
          validate: []
        },
        description: {
          error: '',
          validate: [],
          rtEditor: true
        },
        validFrom: {
          error: '',
          validate: ['empty', 'validFrom']
        },
        validTo: {
          error: '',
          validate: ['empty', 'validTo']
        },
        kpis: {
          error: '',
          validate: []
        }
      },
      selectedYear: null,
      selectedQuarter: null,
      breakthroughStartYear: null,
      breakthroughEndYear: null
    }
  },
  components: {
    DocsInfoLink,
    RTEditor,
    KPIPeriodsModal,
    KPIRecordEditModal
  },
  computed: {
    sysParms () {
      return this.$store.state.sysParms
    },
    newObjective () {
      return this.$store.state.newObjective
    },
    objectivesList () {
      return this.$store.state.objectivesList
    },
    orgUnitsList () {
      return this.$store.state.orgUnitsList
    },
    employees () {
      return this.$store.state.employees
    },
    kpisList () {
      return this.$store.state.kpisList
    },
    selectedKPI () {
      return this.$store.state.selectedKPI
    },
    progress () {
      let progress = 0
      Object.entries(this.newObjective).forEach(entry => {
        if (!['category', 'criterion'].includes(entry[0]) && ((!Array.isArray(entry[1]) && entry[1]) || (Array.isArray(entry[1]) && entry[1].length))) {
          if (((entry[0] === 'name' && entry[1].trim()) || entry[0] !== 'name') && !['responsible', 'description'].includes(entry[0])) {
            progress = progress + (100 / 7)
          }
        }
      })
      return { width: { width: (Math.round(progress) + '%') }, value: Math.round(progress) }
    },
    smart () {
      const smart = { S: false, M: false, A: false, R: false, T: false }
      Object.keys(smart).forEach(key => {
        switch (key) {
          case 'S':
            if (this.newObjective.name?.trim() && this.newObjective.parentId && this.newObjective.orgUnit) {
              smart[key] = true
            }
            break
          case 'M':
            if (this.newObjective.kpis?.length || this.newObjective.keyresults?.length) {
              smart[key] = true
            }
            break
          case 'A':
            if (this.newObjective.name?.trim() && this.newObjective.ambitious) {
              smart[key] = true
            }
            break
          case 'R':
            if (this.newObjective.name?.trim() && this.newObjective.realistic) {
              smart[key] = true
            }
            break
          case 'T':
            if (this.newObjective.validFrom && this.newObjective.validTo) {
              smart[key] = true
            }
            break
        }
      })
      return smart
    },

    categoryEnabled () {
      const model = this.sysParms?.objectiveModel || 'Hybrid'
      return {
        1: model === 'Hoshin' || model === 'Hybrid', // Breakthrough
        0: model === 'Hoshin' || model === 'Hybrid', // Yearly
        2: model === 'OKR' || model === 'Hybrid' // Quarterly
      }
    },

    nextYears () {
      const current = new Date().getFullYear()
      const years = []

      // Breakthrough
      if (this.breakthroughStartYear) years.push(this.breakthroughStartYear)
      if (this.breakthroughEndYear) years.push(this.breakthroughEndYear)

      // Yearly
      if (this.selectedYear) years.push(this.selectedYear)

      // Quarterly
      if (this.selectedQuarter) {
        const yearFromQuarter = Number(this.selectedQuarter.split('-Q')[0])
        years.push(yearFromQuarter)
      }

      // Immer die nächsten 5 Jahre ab heute
      for (let i = 0; i < 5; i++) {
        years.push(current + i)
      }

      // Range bestimmen
      const minYear = Math.min(...years)
      const maxYear = Math.max(...years)

      // Finale Liste
      const result = []
      for (let y = minYear; y <= maxYear; y++) {
        result.push(y)
      }

      return result
    },

    nextQuarters () {
      const current = new Date().getFullYear()
      const years = []

      // Falls ein Quartal ausgewählt ist → Jahr extrahieren
      if (this.selectedQuarter) {
        const yearFromQuarter = Number(this.selectedQuarter.split('-Q')[0])
        years.push(yearFromQuarter)
      }

      // Falls Breakthrough geladen ist → Start/Endjahr berücksichtigen
      if (this.breakthroughStartYear) years.push(this.breakthroughStartYear)
      if (this.breakthroughEndYear) years.push(this.breakthroughEndYear)

      // Falls Yearly geladen ist → Jahr berücksichtigen
      if (this.selectedYear) years.push(this.selectedYear)

      // Immer die nächsten 2 Jahre ab heute (wie bisher)
      years.push(current, current + 1)

      // Range bestimmen
      const minYear = Math.min(...years)
      const maxYear = Math.max(...years)

      // Quartale generieren
      const quarters = []
      for (let year = minYear; year <= maxYear; year++) {
        for (let q = 1; q <= 4; q++) {
          quarters.push({
            label: `${year}-Q${q}`,
            value: `${year}-Q${q}`
          })
        }
      }
      return quarters
    }
  },
  methods: {
    addKPI () {
      this.$store.dispatch('addObjectiveKPI', { kpi: this.kpiSelected })
      this.kpiSelected = { id: 0, name: 'Auswählen...' }
    },
    async selectKPI (kpiId) {
      this.$store.commit('SET_LOADING_STATUS', true)
      await this.$store.dispatch('getKPI', { mode: 'manage', id: kpiId })
      this.$store.commit('SET_LOADING_STATUS', false)
    },
    async recordKPI (kpi) {
      this.$store.commit('SET_LOADING_STATUS', true)
      await this.$store.dispatch('getKPIRecords', { kpiId: kpi.id, selectedYear: this.selectedYear }).then(() => {
        this.$store.state.kpiRecordMode = 'objective'
        this.$store.state.selectedKPI = kpi
      })
      this.$store.commit('SET_LOADING_STATUS', false)
    },
    deleteKPI () {
      this.$store.dispatch('deleteObjectiveKPI', { kpiId: this.kpiSelected.id })
    },
    addKeyResult () {
      if ('keyresults' in this.newObjective) {
        this.newObjective.keyresults.push({})
      } else {
        this.newObjective.keyresults = [{}]
      }
    },
    deleteKeyResult (index) {
      this.newObjective.keyresults.splice(index, 1)
    },
    async save () {
      this.$store.commit('SET_LOADING_STATUS', true)

      let valid = 0

      // Validation: Objective
      Object.keys(this.form).forEach(field => {
        this.form[field].error = ''
        if (this.form[field].rtEditor) {
          this.newObjective[field] = this.$refs['rtEditor-' + field].getContent()
        }

        this.form[field].content = this.newObjective[field]
        this.form[field].validate.forEach(validation => {
          const validationResult = validate.useValidation(this.form, field, validation)
          if (!validationResult.status) {
            this.form[field].error = validationResult.content
            valid++
          }
        })
      })

      // Validation: Key Results
      if (this.criterion === 'KRT') {
        this.newObjective.keyresults.forEach(keyresult => {
          const fields = ['name', 'unit', 'jop', 'obj']
          fields.forEach(field => {
            if (field in keyresult) {
              if (field === 'name' || field === 'unit') {
                if (keyresult[field].trim() !== '' && keyresult[field].length <= 255) {
                  return
                }
              } else if ((field === 'jop' || field === 'obj') && keyresult[field] !== '') {
                return
              }
            }
            valid++
          })
        })
      }

      // Save, if validation without errors
      if (valid === 0) {
        this.newObjective.criterion = this.criterion
        await this.$store.dispatch('addObjective', this.newObjective).then(() => {
          Object.keys(this.form).forEach(field => {
            this.form[field].error = ''
          })
        })
      }

      this.$store.commit('SET_LOADING_STATUS', false)

      await this.$store.dispatch('getObjectives', { validFrom: this.$parent.filterValidFrom, validTo: this.$parent.filterValidTo, treeView: this.$parent.objectivesTreeView })
    },
    toggleObjectivesContentView (objectivesContentView) {
      this.$store.commit('SET_OBJECTIVES_CONTENT_VIEW', objectivesContentView)
    },
    toggleCriterion (criterion) {
      this.criterion = criterion
    },
    updateBreakthroughDates () {
      if (this.newObjective.category !== 1) return

      this.newObjective.validFrom = `${this.breakthroughStartYear}-01-01`
      this.newObjective.validTo = `${this.breakthroughEndYear}-12-31`
    }
  },

  watch: {
    selectedYear (newYear) {
      if (this.newObjective.category === 0) {
        this.newObjective.validFrom = `${newYear}-01-01`
        this.newObjective.validTo = `${newYear}-12-31`
      }
    },

    selectedQuarter (newQuarter) {
      if (this.newObjective.category !== 2) return

      const [year, q] = newQuarter.split('-Q')
      const quarter = Number(q)

      const startMonths = { 1: 1, 2: 4, 3: 7, 4: 10 }
      const endMonths = { 1: 3, 2: 6, 3: 9, 4: 12 }

      const startMonth = startMonths[quarter]
      const endMonth = endMonths[quarter]

      // Startdatum: immer der 1.
      this.newObjective.validFrom =
        `${year}-${String(startMonth).padStart(2, '0')}-01`

      // Enddatum: letzter Tag des Monats
      const lastDay = new Date(year, endMonth, 0).getDate()

      this.newObjective.validTo =
        `${year}-${String(endMonth).padStart(2, '0')}-${lastDay}`
    },

    breakthroughStartYear () {
      this.updateBreakthroughDates()
    },
    breakthroughEndYear () {
      this.updateBreakthroughDates()
    }

  }
}
</script>

<style scoped>
.page-link:active, .page-link:focus {
  box-shadow: none;
  background-color: #fff;
}
@keyframes progress-pusher {
  0%   { opacity: 0 }
  33%  { opacity: 33 }
  66%  { opacity: 66 }
  100% { opacity: 0 }
}
#progress-pusher-1, #progress-pusher-2, #progress-pusher-3 {
  animation: progress-pusher;
  animation-duration: 3s;
  animation-iteration-count: infinite;
}
.selected-kpis input {
  max-width: 10%;
}
</style>
